import {$get, $post} from './axios'
// 将get,post方法绑定到vue原型中，调用即 this.get() ...
export default {
  install(Vue){
    Vue.prototype.get = $get
    Vue.prototype.post = $post
  },
}